<template>
  <v-data-table
    :headers="headers"
    :items="tableItems"
    items-per-page="500"
    :hide-default-footer="true"
    class="elevation-1"
  >
  </v-data-table>
</template>

<script>
export default {
  props: {
    info: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    headers () {
      return [
        { text: 'Firmware Version', value: 'fw_version' },
        { text: 'Number of Devices', value: 'device_count' }
      ]
    },

    tableItems () {
      return this.info
    }
  }
};
</script>
